module.exports = __webpack_public_path__ + "img/home_head.1b54ee25.png";